import React, { useState } from 'react';

const BookingContext = React.createContext({} as any);

const searchParams = Object.fromEntries(new URLSearchParams(window.location.search));
let locale = searchParams.locale || navigator.language;
if (
  locale !== 'de' &&
  locale !== 'en'
) locale = 'de';

const org = searchParams.org;

function BookingProvider(props: any) {
  const [courses, setCourses] = useState<any[]>([]);

  function addCourse(course) {
    let array: any[] = [];

    if (!courses.includes(course)) {
      for (const previousCourse of courses) {
        if (
          previousCourse.part === course.part &&
          previousCourse.type === course.type
        ) continue;

        array.push(previousCourse);
      }

      array.push(course);
    } else {
      array = courses.filter(c => c !== course)
    }

    setCourses(array);
  }

  return (
    <BookingContext.Provider value={{ courses, addCourse, locale, org }} {...props} />
  );
}

function useBooking() {
  return React.useContext(BookingContext);
}

export { BookingProvider, useBooking };